import React from 'react';
import { Section } from './ui/Section';
import { CTAButton } from './ui/CTAButton';
import { ShieldCheck } from 'lucide-react';
export function OfferSection() {
  return <Section bg="cream" id="offer-section" className="pb-24" data-id="element-151">
      <div className="max-w-4xl mx-auto bg-white rounded-[2.5rem] p-8 md:p-12 shadow-2xl border-4 border-[#F59E0B]/20 relative overflow-hidden" data-id="element-152">
        {/* Decorative corner */}
        <div className="absolute top-0 right-0 w-32 h-32 bg-[#FFF8F0] rounded-bl-full -z-0" data-id="element-153"></div>

        <div className="relative z-10 grid md:grid-cols-2 gap-10 items-center" data-id="element-154">
          <div className="order-2 md:order-1" data-id="element-155">
            <h2 className="text-3xl md:text-4xl font-black text-[#422006] mb-6 leading-tight" data-id="element-156">
              Recupera tu tiempo, tu energía y tu paz mental.
            </h2>
            <p className="text-lg text-[#78350F] mb-8 leading-relaxed" data-id="element-157">
              Por menos de lo que cuesta una cena de comida rápida que te hace
              sentir pesada, obtén el sistema que te liberará de la cocina para
              siempre.
            </p>

            <div className="bg-[#FFF8F0] rounded-2xl p-6 mb-8 border border-[#F59E0B]/30 text-center" data-id="element-158">
              <div className="text-2xl font-bold text-[#78350F]/60 line-through decoration-[#EA580C] decoration-2 mb-1" data-id="element-159">
                $22 <span className="text-base" data-id="element-160">USD</span>
              </div>
              <div className="text-xs font-black uppercase tracking-widest text-[#F59E0B] mb-1" data-id="element-161">
                Oferta
              </div>
              <div className="text-5xl font-black text-[#EA580C]" data-id="element-162">
                $6.39 <span className="text-2xl" data-id="element-163">USD</span>
              </div>
            </div>

            <CTAButton className="w-full text-center flex justify-center" href="https://pay.hotmart.com/E104986676K" data-id="element-164" />

            <div className="mt-6 flex items-center justify-center gap-2 text-sm text-[#78350F] opacity-80 font-medium" data-id="element-165">
              <ShieldCheck size={18} className="text-[#F59E0B]" data-id="element-166" />
              <span data-id="element-167">
                Acceso inmediato en PDF. Formato optimizado para leer desde tu
                celular mientras cocinas.
              </span>
            </div>
          </div>

          <div className="order-1 md:order-2 relative" data-id="element-168">
            <div className="absolute inset-0 bg-gradient-to-tr from-[#F59E0B]/20 to-transparent rounded-2xl transform rotate-3 scale-105" data-id="element-169"></div>
            <img src="https://cdn.magicpatterns.com/uploads/cU3kTSfdKjvwPv8QpJ8mG9/portada_4.png" alt="Menús Express Ebook" className="relative z-10 w-full h-auto rounded-2xl shadow-xl border-4 border-white transform -rotate-2 hover:rotate-0 transition-transform duration-500" data-id="element-170" />
          </div>
        </div>
      </div>
    </Section>;
}